/**
 * LI item producer for rendering list items inside popups.
 */

import clsx from 'clsx';
import {GoDeeperArrow} from './go_back_forward_arrow';
import * as React from 'react';

interface ListItemPopupRendererProps {
    taskData: TaskData;
    dom_id: string;
    extraLiClass?: string;
    filterTerms: string[];

    forwardAction: (e: Event) => void;
    forwardRunning: boolean;
}

const ListItemPopupRenderer = (props: ListItemPopupRendererProps) => {

    const item = props.taskData;

    var renderer = new maxkir.SearcherTaskRenderer(item, props.filterTerms, props.dom_id);

    let deeperArrow: JSX.Element = null;
    if (item.tasks && item.tasks.length > 0) {
        deeperArrow = <GoDeeperArrow forwardAction={props.forwardAction} running={props.forwardRunning}/>;
    }

    var classes = clsx("popupListItemLi", props.extraLiClass, renderer.li_class());

    return <li className={classes} id={renderer.li_id()} key={"task_" + renderer.li_id()}
               ><div dangerouslySetInnerHTML={{__html: renderer.full_task_content()}}></div>{deeperArrow}</li>
}

export default ListItemPopupRenderer;
